import { render } from "./Markdown.vue?vue&type=template&id=a0c57e28"
import script from "./Markdown.vue?vue&type=script&lang=js"
export * from "./Markdown.vue?vue&type=script&lang=js"
script.render = render

export default script